import { CollaboratorCommissionAllResponse } from "app/types/comisiones";
import axios from "axios"
const API_URL = process.env.REACT_APP_API_NET;

/**
 * @param idUsuario nameId when we use the token
 * @param page 
 * @param pageSize 
 * @returns 
 */
export async function getAllCollaboratorCommission(idUsuario: number | string, page: number | string, pageSize: number | string) {
    try {
        const response = await axios.get<CollaboratorCommissionAllResponse>(`${API_URL}CollaboratorCommissions?UserId=${idUsuario}&Page=${page}&PageSize=${pageSize}`);

        return response.data.data;
    } catch (err) {
        console.error("Error fetching all collaborator comission", err)
    }
}

export const getCollaboratorCommissionNameAndNumber = async (idUsuario: number | string, page: number | string, pageSize: number | string, employeeName?: string, employeeNumber?: string) => {
    try {
        //GETEMPLOYEE NAME
        const response = await axios.get(`${API_URL}CollaboratorCommissions/GetByEmployeeName?UserId=${idUsuario}&EmployeeName=${employeeName}&Page=${page}&PageSize=${pageSize}`);

        return response.data.data;
    } catch (err) {
        console.error("Error fetching filter info ", err)
        throw err;
    }
}

export const getCollaboratorCommissionNumber = async (idUsuario: number | string, page?: number | string, pageSize?: number | string, employeeNumber?: string) => {
    try {
        //GETEMPLOYEE NUMBER
        const response = await axios.get(`${API_URL}CollaboratorCommissions/GetByEmployeeNumber?UserId=${idUsuario}&EmployeeNumber=${employeeNumber}&Page=${page}&PageSize=${pageSize}`);


        return response.data.data;
    } catch (err) {
        console.error("Error fetching filter info ", err)
        throw err;
    }
}

export const updateCollaboratorCommission = async (commissionId : number, finalCommissionAmount : number, idUsuario: number) => {
    try {
        const response = await axios.put(`${API_URL}CollaboratorCommissions/PutCollaboratorCommission?CommissionId=${commissionId}&FinalCommissionAmount=${finalCommissionAmount}&UserId=${idUsuario}`);
        return response.data.data;
    } catch (err) {
        console.error("Error updating collaborator comission", err)
    }
}

export async function putRequestOpening(idUser: number | string, idPeriod: number | string) {
  try {
    const response = await axios.put(`${API_URL}CollaboratorCommissions/PutRequestOpening?Id_user=${idUser}&Id_period=${idPeriod}`);
    return response.data;
  } catch (err) {
    console.error("Error en putRequestOpening:", err);
    throw err;
  }
}

export async function putOpeningAuthorization(idUser: number | string, idPeriod: number | string) {
  try {
    const response = await axios.put(`${API_URL}CollaboratorCommissions/PutOpeningAuthorization?Id_user=${idUser}&Id_period=${idPeriod}`);
    return response.data;
  } catch (err) {
    console.error("Error en putOpeningAuthorization:", err);
    throw err;
  }
}